import { BattleUnit, FactionType, TurnPool } from '@/core/types/battle.types';
import { BattleStore } from './useBattleStore'; // шлях до твого стору



// 1. ПЕРЕВІРКА ЗАВЕРШЕННЯ ХОДУ (Unit Finished)
// Семантично: Чи використав юніт свій ресурс ходу в цьому раунді?
export const isUnitFinished = (state: BattleStore, unitId: string): boolean => {
    return state.finishedPools.some((pool: TurnPool) => pool.unitIds.includes(unitId));
};

// 2. ПЕРЕВІРКА АКТИВНОСТІ (Unit Active)
// Семантично: Чи знаходиться юніт у пулі, який зараз має право ходу?
export const isUnitInActivePool = (state: BattleStore, unitId: string): boolean => {
    const activePool = getActivePool(state);
    return activePool?.unitIds.includes(unitId) ?? false;
};

// 3. ОТРИМАННЯ АКТИВНОГО ПУЛУ (Active Pool)
// Семантично: Повертає об'єкт пулу, який зараз діє.
export const getActivePool = (state: BattleStore): TurnPool | null => {
    return state.turnQueue[0] || null;
};

export const getActiveUnit = (state: BattleStore): BattleUnit | null => {
  if (!state.selectedUnitId) return null;
  
  const unit = state.units.get(state.selectedUnitId);
  return unit ?? null; // Перетворюємо undefined від Map.get у null
};

export const getActivePlayerUnit = (state: BattleStore): BattleUnit | null => {
  const activeUnit = getActiveUnit(state);
  
  return activeUnit && activeUnit.faction === FactionType.Player ? activeUnit : null;
};